var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isPageLoading
    ? _c(
        "div",
        [
          _vm.hasAdminAccess && (_vm.user != null || _vm.currentuser != null)
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isLoggedInUserActive,
                          expression: "!isLoggedInUserActive"
                        }
                      ]
                    },
                    [
                      _c("label", { staticStyle: { color: "red" } }, [
                        _vm._v(_vm._s(_vm.$t("msguserisnotactive")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLoggedInUserActive,
                        expression: "isLoggedInUserActive"
                      }
                    ],
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.plantUsers,
                      search: _vm.search,
                      "footer-props": {
                        itemsPerPageOptions: _vm.tableItemsPerPage,
                        itemsPerPageText: _vm.rowsperpage
                      },
                      options: _vm.options
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "top",
                          fn: function() {
                            return [
                              _c(
                                "v-dialog",
                                {
                                  attrs: { "max-width": "500px" },
                                  model: {
                                    value: _vm.dialogDelete,
                                    callback: function($$v) {
                                      _vm.dialogDelete = $$v
                                    },
                                    expression: "dialogDelete"
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    { attrs: { light: "", flat: "" } },
                                    [
                                      _c(
                                        "v-card-title",
                                        { staticClass: "headline" },
                                        [
                                          _vm._v(
                                            "Are you sure you want to delete this item?"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c("v-progress-circular", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.deleteinProgress,
                                                expression: "deleteinProgress"
                                              }
                                            ],
                                            attrs: {
                                              indeterminate: "",
                                              color: "primary"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.deleteinProgress,
                                                  expression:
                                                    "!deleteinProgress"
                                                }
                                              ],
                                              attrs: {
                                                color: "blue darken-1",
                                                text: ""
                                              },
                                              on: { click: _vm.closeDelete }
                                            },
                                            [_vm._v("Close")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.deleteinProgress,
                                                  expression:
                                                    "!deleteinProgress"
                                                }
                                              ],
                                              attrs: {
                                                color: "blue darken-1",
                                                text: ""
                                              },
                                              on: {
                                                click: _vm.deleteItemConfirm
                                              }
                                            },
                                            [_vm._v("OK")]
                                          ),
                                          _vm._v(" "),
                                          _c("v-spacer")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-toolbar",
                                { attrs: { flat: "", dense: "" } },
                                [
                                  _c("h3", [_vm._v(_vm._s(_vm.$t("users")))]),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    staticClass: "mx-4",
                                    attrs: { inset: "", vertical: "" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mb-2",
                                      attrs: { color: "primary", dark: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openNewUser()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.$t("new")) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-dialog",
                                    {
                                      attrs: { "max-width": "500px" },
                                      model: {
                                        value: _vm.dialog,
                                        callback: function($$v) {
                                          _vm.dialog = $$v
                                        },
                                        expression: "dialog"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        [
                                          _c(
                                            "v-card-title",
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "headline" },
                                                [_vm._v(_vm._s(_vm.formTitle))]
                                              ),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-icon",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.close(1)
                                                    }
                                                  }
                                                },
                                                [_vm._v("close")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-container",
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      !_vm.isEditUser
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                sm: "8",
                                                                md: "8"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-autocomplete",
                                                                {
                                                                  staticStyle: {
                                                                    "background-color":
                                                                      "#ffffcc"
                                                                  },
                                                                  attrs: {
                                                                    items:
                                                                      _vm.items,
                                                                    loading:
                                                                      _vm.isLoading,
                                                                    "search-input":
                                                                      _vm.searchapi,
                                                                    color:
                                                                      "black",
                                                                    "hide-no-data":
                                                                      "",
                                                                    "hide-selected":
                                                                      "",
                                                                    "item-text":
                                                                      "givenName",
                                                                    "item-value":
                                                                      "email",
                                                                    placeholder:
                                                                      _vm.$t(
                                                                        "searchuser"
                                                                      ) + " *",
                                                                    "prepend-icon":
                                                                      "mdi-account-search",
                                                                    clearable:
                                                                      "",
                                                                    "return-object":
                                                                      ""
                                                                  },
                                                                  on: {
                                                                    "update:searchInput": function(
                                                                      $event
                                                                    ) {
                                                                      _vm.searchapi = $event
                                                                    },
                                                                    "update:search-input": function(
                                                                      $event
                                                                    ) {
                                                                      _vm.searchapi = $event
                                                                    },
                                                                    "click:clear": function(
                                                                      $event
                                                                    ) {
                                                                      _vm.model = null
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.model,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.model = $$v
                                                                    },
                                                                    expression:
                                                                      "model"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.model
                                                                ? _c("div", [
                                                                    _vm.isAzureDeployed ==
                                                                    1
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "red lighten-3"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                    " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .fields[4]
                                                                                    .value
                                                                                ) +
                                                                                "\n                                                "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "red lighten-3"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                    " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .fields[0]
                                                                                    .value
                                                                                ) +
                                                                                "\n                                                "
                                                                            )
                                                                          ]
                                                                        )
                                                                  ])
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        : _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                sm: "8",
                                                                md: "8"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                            User Info:\n                                            "
                                                              ),
                                                              _c("h3", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.searchUser
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "red lighten-3"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                " +
                                                                      _vm._s(
                                                                        _vm.addUserEmail
                                                                      ) +
                                                                      "\n                                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "8",
                                                            md: "8"
                                                          }
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            staticStyle: {
                                                              "background-color":
                                                                "#ffffcc"
                                                            },
                                                            attrs: {
                                                              items: _vm.plants,
                                                              label:
                                                                _vm.$t(
                                                                  "plant"
                                                                ) + " *",
                                                              "item-text":
                                                                "plant",
                                                              "item-value": "id"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.changePlant
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.selecttedplant,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.selecttedplant = $$v
                                                              },
                                                              expression:
                                                                "selecttedplant"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "8",
                                                            md: "8"
                                                          }
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            staticStyle: {
                                                              "background-color":
                                                                "#ffffcc"
                                                            },
                                                            attrs: {
                                                              items:
                                                                _vm.companies,
                                                              label:
                                                                _vm.$t(
                                                                  "company"
                                                                ) + " *",
                                                              "item-text":
                                                                "value",
                                                              "item-value":
                                                                "id",
                                                              readonly:
                                                                _vm.companyreadOnly
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.selectedcontractor,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.selectedcontractor = $$v
                                                              },
                                                              expression:
                                                                "selectedcontractor"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "8",
                                                            md: "8"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-radio-group",
                                                            {
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#ffffcc"
                                                              },
                                                              attrs: {
                                                                row: ""
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.isUserActive,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.isUserActive = $$v
                                                                },
                                                                expression:
                                                                  "isUserActive"
                                                              }
                                                            },
                                                            [
                                                              _c("v-radio", {
                                                                attrs: {
                                                                  label: _vm.$t(
                                                                    "active"
                                                                  ),
                                                                  value: "Y"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("v-radio", {
                                                                attrs: {
                                                                  label: _vm.$t(
                                                                    "notactive"
                                                                  ),
                                                                  value: "N"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "8",
                                                            md: "8"
                                                          }
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            staticStyle: {
                                                              "background-color":
                                                                "#ffffcc"
                                                            },
                                                            attrs: {
                                                              items:
                                                                _vm.languages,
                                                              label:
                                                                _vm.$t(
                                                                  "language"
                                                                ) + " *",
                                                              "item-text":
                                                                "language",
                                                              "item-value": "id"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.selectedlanguage,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.selectedlanguage = $$v
                                                              },
                                                              expression:
                                                                "selectedlanguage"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                            md: "6"
                                                          }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "otherinfo"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.editedItem
                                                                  .otherInfo,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.editedItem,
                                                                  "otherInfo",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "editedItem.otherInfo"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-actions",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "blue darken-1",
                                                    text: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.close(1)
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("cancel"))
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    color: "primary",
                                                    dark: ""
                                                  },
                                                  on: { click: _vm.save }
                                                },
                                                [_vm._v(_vm._s(_vm.$t("save")))]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    staticClass: "mx-4",
                                    attrs: { inset: "", vertical: "" }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "mdi-magnify",
                                      label: _vm.$t("searchall"),
                                      "single-line": "",
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "item.action",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { small: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editItem(item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    mdi-pencil\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-icon",
                                {
                                  attrs: { small: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteItem(item)
                                    }
                                  }
                                },
                                [_vm._v(" mdi-delete ")]
                              )
                            ]
                          }
                        },
                        {
                          key: "no-data",
                          fn: function() {
                            return [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary" },
                                  on: { click: _vm.getUserHCFromAPI }
                                },
                                [_vm._v("Reset")]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            : _vm.user != null || _vm.currentuser != null
            ? _c(
                "v-alert",
                {
                  attrs: {
                    outlined: "",
                    type: "warning",
                    prominent: "",
                    border: "left"
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("accessdenied")) + "\n    "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _c(
        "div",
        [
          _c("v-progress-linear", {
            attrs: {
              indeterminate: "",
              color: "teal",
              rounded: "",
              height: "8"
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73968b0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73968b0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User.vue
// module id = null
// module chunks = 